export default "__VITE_ASSET__BqiG3Yg4__"